import {CURRENCY, SUBJECT_TYPE, TARGET_PRICE_TYPE} from "../modules/members/listings/create/js/constants";

export function scrollToElement($element, time, padTop) {
    var startTop = null;

    if (!$element) {
        // TODO: show error in log or console or elsewhere
        return;
    }

    if (!time) {
        time = 1000;
    }

    if (!padTop) {
        startTop = $element.offset().top;
    } else {
        startTop = $element.offset().top - padTop; 
    }

    $('html, body').animate({
        scrollTop: startTop
    }, time);
}

export function toggleTwoElms(hides, shows) {
    $(hides).hide();
    $(shows).show();
};

export function getEmailPattern() {
    return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/;
}

export function doEmailPatternTest(strToTest) {
    var foundPattern = false;
    var emailpattern = getEmailPattern();
    if (emailpattern.test(strToTest) !== false) {
        foundPattern = true;
    }
    return foundPattern;
}

export function doPatternTestFromElement($element) {
    var foundPattern = true;
    if ($element.attr('data-pattern') && !(new RegExp($element.attr('data-pattern')).test($element.val()))) {
        foundPattern = false;
    }
    return foundPattern;
}

export function getPatternMessageFromElement($element) {
    return $element.attr('data-pattern-message') ? $element.attr('data-pattern-message') : 'Value is incorrect.';      
}

export function getContactPatterns() {
    return [
        /^(?=.*\bskype\b).*$/gi,
        /^(?=.*\bwhatsapp\b).*$/gi,
        /^(?=.*\bcall)(?=.*\bme\b).*$/gi,
        /^(?=.*\bemail)(?=.*\bme\b).*$/gi,
        /^(?=.*\bdot)(?=.*\bcom\b).*$/gi,
        /^(?=.*\b\.com\b).*$/gi,
    ];
}

export function doContactInfoTest(strToTest) {
    var foundPattern = false;

    $.each(getContactPatterns(), function(i, wp) {
        var patternToTest = wp.test(strToTest);
        if (patternToTest) {
            foundPattern = true; 
            return false;
        }
    });
    
    return foundPattern;
}

export function getCtaFromElement(elm) {
    return $(elm).data('cta');
}

export function randomNumberBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export function addCommasToNumber(number) {
    number += '';
    var x = number.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

export function removeCommasFromNumber(num) {
    var x = num.toString();
    x = x.replace(/\,/g,'');
    return Number(x);
}

export function roundToDecimals(value, decimals) {
    var x = removeCommasFromNumber(value);
    return Number(Math.round(x +'e'+ decimals) +'e-'+ decimals).toFixed(decimals);
}

export function isNumberFloats(mxv) {
    return +mxv === mxv && (!isFinite(mxv) || !!(mxv % 1))
}

export function copyToClipboard(htmlElement, callback) {
    if (htmlElement.tagName.toUpperCase() !== 'INPUT' && htmlElement.tagName.toUpperCase() !== 'TEXTAREA') {
        console.log('Element should be <input> or <textarea>', htmlElement);
        return;
    }

    htmlElement.select();
    htmlElement.setSelectionRange(0, 9999);
    document.execCommand('copy');

    if (typeof callback === 'function') {
        callback();
    }
}

export function addEllipsis(string, length) {
    if (!string || string === '' || !length) {
        return string;
    }

    if (string.length <= length) {
        return string;
    }

    return string.slice(0, length).trim() + '...';
}

export function maskEmailsInText(txt) {
    var re = new RegExp(String.fromCharCode(160), "g");
    txt = txt.replace(re, " ");
    txt = txt.replace(/(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi, '[email withheld]');
    return txt;
}

export function format_price(price, showCents, currency) {
    var fPrice = '';
    var strP = price.toString();
    var intP = parseFloat(strP);

    var inPFlt = intP.toFixed(2);
    var strPFlt = inPFlt.toString();
    var isFlZero = strPFlt.indexOf(".00");

    if (isFlZero !== -1) {
        fPrice = showCents === true ? addCommasToNumber(intP.toFixed(2)) : addCommasToNumber(intP);
    } else {
        fPrice = addCommasToNumber(intP.toFixed(2));
    }

    if (!!currency) {
        fPrice = currency.toString() + fPrice;
    }

    return fPrice;
}

export function stringToBooleanVal(string) {
    try {
        switch (string.toString().toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1":
                return true;
            case "false":
            case "no":
            case "0":
            case null:
                return false;
            default:
                return Boolean(string);
        }
    } catch {
        return false;
    }
}

export function stringSpaceToDashLowerCase(string) {
    return string.replace(/\s+/g, '-').toLowerCase();
}

export function setElmAttributes(elm, attrs) {
    Object.keys(attrs).forEach(key => elm.setAttribute(key, attrs[key]));
}

export function load_image(gid, image_path, image_alt) {
    var img = new Image();
    $(img)
        .on("load", function() {
            $('#item-' + gid).find('.listing__image-link').append(this);
        })
        .attr('src', image_path)
        .attr('alt', image_alt)
        .attr('width', '70')
        .attr('height', '70')
        .addClass('listing__image-thumb');
}

export function getPriceHTML(item) {
    var priceFormatted = format_price(item.price);
    var currency = item.currency && item.currency === CURRENCY.eur ? '€' : '$';

    if (item.subject_typeid === SUBJECT_TYPE.wtb) {
        return '<strong class="tl-color--wtb">' + currency + priceFormatted + '</strong> each';
    } else if (parseInt(item.target_price_typeid[0]) === TARGET_PRICE_TYPE.lot) {
        return '<strong class="tl-color--wts">' + currency + priceFormatted + '</strong> / lot';
    } else {
        return '<strong class="tl-color--wts">' + currency + priceFormatted + '</strong> each';
    }
}

export function getQuantityHTML(item) {
    let quantity = addCommasToNumber(item.quantity);

    if (item.subject_typeid === SUBJECT_TYPE.wtb) {
        return '<strong class="tl-color--wtb">' + quantity + '</strong> Needed'
    } else {
        if (parseInt(item.target_price_typeid[0]) === TARGET_PRICE_TYPE.lot) {
            return 'Lot of <strong class="tl-color--wts">' + quantity + '</strong>';
        } else {
            return '<strong class="tl-color--wts">' + quantity + '</strong> Available';
        }
    }
}

export function getPriceQuantityHTML(item) {
    const priceFormatted = format_price(item.price);
    const qtyFormatted = addCommasToNumber(item.quantity);

    if (item.subject_typeid === SUBJECT_TYPE.wtb) {
        return '<strong class="tl-color--wtb">$' + priceFormatted + '</strong> each';
    } else if (parseInt(item.target_price_typeid[0]) === TARGET_PRICE_TYPE.lot) {
        return '<strong class="tl-color--wts">$' + priceFormatted + '</strong> / lot of <strong class="tl-color--wts">' + qtyFormatted + '</strong>';
    } else {
        return '<strong class="tl-color--wts">$' + priceFormatted + '</strong> each';
    }
}

export function getItemShippingCountry(item) {
    let result = '';

    if (typeof item.ships_from_country !== 'undefined' && item.ships_from_country.length > 0) {
        const title = (item.subject_typeid === SUBJECT_TYPE.wtb ? 'Destination ' : 'Ships from ') + item.ships_from_country;
        result = '<span class="flag flag-' + item.ships_from_country_code + '" data-toggle="tooltip" title="' + title + '"></span>';
    }

    return result;
}

export function getRepliesLabelHTML(item) {
    if (!item || !item.is_logged_in) {
        return;
    }

    if (item.self && item.hasReply || item.replied) {
        let result = '<span class="listing__replies">';

        if (item.self && item.hasReply) {
            result += '&nbsp;&nbsp;<strong><a href="' + item.inquiriesUrl + '">(' + item.replyCount + ' <span class="fas fa-envelope color-grey fs-12" aria-hidden="true"></span>)</a></strong>';
        }

        if (item.replied) {
            result += '<strong><a href="' + item.messageReplyUrl + '">your inquiry</a></strong>';
        }

        result += '</span>';
        return result;
    }

    return '';
}

export function getRepliesHTML(item) {
    if (!item) {
        return;
    }

    if (parseInt(item.repliesNumber) > 0) {
        return '<a href="javascript:void(0);">' + parseInt(item.repliesNumber) + ' inquiries</a>';
    } else {
        return 'no inquiries';
    }
}

export function strip(html){
    if (!html || html.length === 0) {
        return '';
    }

    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export function clean(txt) {
    if (!txt || txt.length === 0) {
        return '';
    }

    var re = new RegExp(String.fromCharCode(160), "g");
    txt = txt.replace(re, " ");
    txt = txt.replace(/(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi, '[email witheld]');
    return txt;
}

export function pluralize(cnt,s,p){
    if (cnt > 1 || cnt === 0) {
        return p;
    } else {
        return s;
    }
}

export function replyCount(id) {
    if (typeof created != 'undefined') {
        if (created.hasOwnProperty(id + "")) {
            return created[id + ""]['replies'];
        }
    }
    return 0;
}

export function getURLParameterValue(sPageURL, sParam) {
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }
    return null;
}

export function setURLParameter(url, paramName, paramValue) {
    if (!url || !paramName) return;

    var result = url.split('?');
    var paramsList = result[1];

    if (!paramsList) return;

    if (paramsList.indexOf(paramName) === -1) {
        result[1] += '&' + paramName + '=' + paramValue.toString();
    } else {
        var re = new RegExp(paramName + '=[0-9a-zA-Z\-]+', 'g');
        result[1] = paramsList.replace(re, paramName + '=' + paramValue);
    }

    return result.join('?');
}

// TODO: test with:
// source: '    Lorem!? IPSUM - dolor; sit't amet, consectetur: adipiscing, elit...   '
// result: 'lorem-ipsum-dolor-sitt-amet-consectetur-adipiscing-elit'
export function slugify(string) {
    if (!string) {
        return;
    }

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^a-z0-9\-]/g, '') // Replace special characters with ''
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
}

// TODO: duplicated in data.js
export function getListingUrl(item, slug_subject_type, cat_tree, messageSubject) {
    var rtn = '/' + slug_subject_type.toLowerCase() + cat_tree.toLowerCase() + '/' + messageSubject.toLowerCase() + '?id=' + item.tradefeed_id;

    /*
    if (item.is_expired) {
        rtn += '&expired=true';
    } else {
        rtn += '&active=true';
    }
    */

    return rtn;
}

export function isPassword(value) {
    const pattern = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*()+=,.<>?_-]+)$/;
    const letters = /^(.*[a-zA-Z]+.*)$/;
    const numbers = /^(.*[0-9]+.*)$/;

    if (value === '') {
        return false;
    }

    if (value.length < 8 || value.length > 24) {
        return false;
    }

    if (!letters.test(value) || !numbers.test(value) || !pattern.test(value)) {
        return false;
    }

    return true;
}

export function sanitizeTextInput(input) {
    if (!input) return '';
    return framework.removeHTML(framework.strip(input));
}

export function getDaysFromMilliseconds(ms) {
    return Math.floor(ms / (1000 * 60 * 60 * 24));
}

export function addCommas(nStr){
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

export function boldString(str, find) {
    if (!str) {
        return "";
    }

    try {
        var re = new RegExp(find, 'gi');
        var matches = str.match(re);
        if (matches) {
            $.each(matches, function(i, match) {
                //var rex = new RegExp("[^\\>]?"+match+"[^\\<]", 'g');
                try {
                    var rex = new RegExp(match, 'g');
                    str = str.replace(rex, '<b>' + match + '</b>');
                } catch (e) {
                    // regex error
                }
            });
        }
    } catch (e) {
        // regex error
    }

    return str;
}

export function blueString(str, find, text) {
    if (!text) {
        return "";
    }

    try {
        var re = new RegExp(find, 'gi');
        var matches = text.match(re);
        if (matches) {
            str = '<span class="tl-color--tertiary">' + str + '</span>';
        }
    } catch (e) {
        // regex error
    }

    return str;
}

export function highlightString(str, find) {
    if (!str) {
        return "";
    }

    if (str.length < 3) {
        return str;
    }

    try {
        var re = new RegExp(find, 'gi');
        var matches = str.match(re);
        if (matches) {
            $.each(matches, function(i, match) {
                try {
                    //var rex = new RegExp("[^\\>]?"+match+"[^\\<]", 'g');
                    var rex = new RegExp(match, 'g');
                    str = str.replace(rex, '<span class="tl-highlighted-light">' + match + '</span>');
                } catch (e) {
                    // regex error
                }
            });
        }
    } catch (e) {
        // regex error
    }

    return str;
}

export function doTextHighlight(docPart,textToHighlight){
    const container = document.getElementById(docPart);

    if (!container || !textToHighlight || textToHighlight.length === 0) {
        return;
    }

    const words = textToHighlight.split(' ');
    if (words.length > 0) {
        words.forEach(word => {
            word = removeSpecialCharsFromSolrQuery(word);
            InstantSearch.highlight(container, word);
        });
    }
}

export function isSiteOnline(url,callback) {
    // try to load favicon
    var url_val = url.trim().toLowerCase();

    $('#loading').show();
    $('#red_crossimg').hide();
    $('#check_img').hide();
    $("#loading").html("<img src='/images/ajax/arrow-spinner-128.gif' height='16px;' width='16px;'>");

    if(url_val == 'https://none'){
        callback(true);
    }
    else{
        var timer = setTimeout(function(){
            // timeout after 2 seconds
            callback(false);
        },5000)

        var img = document.createElement("img");
        img.onload = function() {
            clearTimeout(timer);
            callback(true);
        }

        img.onerror = function() {
            clearTimeout(timer);
            callback(false);
        }

        img.src = url+"/favicon.ico";
    }
}

function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}

export function guid() {
    return (S4()+S4()+""+S4()+""+S4()+""+S4()+""+S4()+S4()+S4());
}

export function url(e) {
    return window.$baseurl + '/' + e;
}

export function isAllowedFileExtension(fileName, allowedExtArr) {
    var arr = fileName.split('.');
    var ext = arr[arr.length - 1];
    return allowedExtArr.indexOf(ext) !== -1;
}

export function checkWebsite(URL, success, error) {
    var lURL = URL.toLowerCase();
    var pings = 'https://radar.' + window.this_site_domain + '/feeds/stats/urls/pingUrl.cfm?urlPing=https://' + URL;

    if (lURL === '' || lURL === 'none') {
        return;
    }

    $.ajax({
        type: "GET",
        url: pings,
        success: function(r) {
            if (r.valid) {
                if (typeof success == 'function') {
                    success();
                }
            } else {
                if (typeof error == 'function') {
                    error();
                }
            }
        },
        error: function() {
            if (typeof error == 'function') {
                error();
            }
        }
    });
}

export function getFormData($form) {
    const rawData = $form.serializeArray();
    let result = {};

    $.map(rawData, function(n, i){
        result[n['name']] = n['value'];
    });

    return result;
}

export function deleteFilterLine(filter_str, field) {
    const index = filter_str.findIndex((item, i) => {
        return item.indexOf(field) !== -1;
    });

    if (index !== -1) {
        delete filter_str[index];
    }

    return filter_str;
}

export function decodeHTMLEntities(string) {
    string += '';

    if (!string || string.length === 0) {
        return;
    }

    const textArea = document.createElement('textarea');
    textArea.innerHTML = string;
    return textArea.value;
}

export function escapeUnescapedDoubleQuotes(str) {
    if (!str || str.length === 0) {
        return '';
    }

    const regex = /((?:^|[^\\])(?:\\{2})*)"/gm;
    const subst = `$1\\"`;

    return str.replace(regex, subst);
}

export function escapeSpecialCharsForSolrQuery(str) {
    if (!str || str.length === 0) {
        return '';
    }

    // Regular expression to escape special characters in Solr/Lucene queries, following Lucene query parser documentation:
    // https://lucene.apache.org/core/3_6_0/queryparsersyntax.html#Escaping%20Special%20Characters
    return str.replace(/([+\-!(){}\[\]^"~*?:\\/])/g, '\\$1');
}

export function removeSpecialCharsFromSolrQuery(str) {
    if (!str || str.length === 0) {
        return '';
    }

    return str.replace(/([+\-!(){}\[\]^"~*?:\\/])/g, '');
}

/**
 * Check if an offer price is a lowball (< 50% of asking price) and show modal warning
 * @param {number} priceEntered - The price the user entered
 * @param {boolean} debugMode - Debug mode flag for logging
 * @returns {Promise<boolean>} - Resolves with true if user should proceed, false if cancelled
 */
export function doLowballCheck(priceEntered, debugMode) {
    // Constants
    const LOWBALL_THRESHOLD = 0.50; // 50% of asking price
    const MODAL_SELECTOR = '#lowballWarningModal';
    const MESSAGE_SELECTOR = '#lowball_warning_message';
    const PROCEED_BUTTON_SELECTOR = '#lowball_proceed_button';
    const CANCEL_BUTTON_SELECTOR = '.modal .btn-done';

    /**
     * Generate lowball warning message based on price visibility
     * @param {number} price - The price the user entered
     * @param {number} asking - The listing's asking price
     * @param {boolean} hidden - Whether the asking price is hidden
     * @returns {string} - HTML message to display in modal
     */
    function getLowballMessage(price, asking, hidden) {
        const formattedPrice = format_price(price);

        if (hidden) {
            return `Your offer of <strong>$${formattedPrice}</strong> appears far below market. This offer is unlikely to be considered.`;
        }

        return `Your offer of <strong>$${formattedPrice}</strong> is far below the asking price (<strong>$${format_price(asking)}</strong>). This offer is unlikely to be considered.`;
    }

    return new Promise((resolve) => {
        const $offerPrice = $('#offer_price');
        const askingPrice = parseFloat($offerPrice.attr('data-asking-price'));
        const isPriceHidden = $offerPrice.attr('data-price-hidden') === '1';
        const lowballThreshold = askingPrice * LOWBALL_THRESHOLD;

        if (debugMode) {
            console.log('CHECK LOWBALL:');
            console.log('PRICE ENTERED: ' + priceEntered);
            console.log('ASKING PRICE: ' + askingPrice);
            console.log('LOWBALL THRESHOLD (50%): ' + lowballThreshold);
            console.log('IS PRICE HIDDEN: ' + isPriceHidden);
        }

        // Don't show warning if asking price is not available or invalid
        if (isNaN(askingPrice) || askingPrice <= 0 || isNaN(priceEntered) || priceEntered <= 0) {
            resolve(true); // No error, continue
            return;
        }

        if (priceEntered < lowballThreshold) {
            const message = getLowballMessage(priceEntered, askingPrice, isPriceHidden);

            // Show modal
            tradeloop.modal('transactions/offers/lowball_warning', function() {
                $(MESSAGE_SELECTOR).html(message);

                // Find the modal element and initialize it as Bootstrap modal if needed
                const $modal = $(MODAL_SELECTOR);
                if (!$modal.data('bs.modal')) {
                    $modal.modal({backdrop: 'static', keyboard: false});
                }

                // Handle proceed button
                $(PROCEED_BUTTON_SELECTOR).on('click', function() {
                    if (debugMode) {
                        console.log('LOWBALL OFFER PROCEEDING');
                    }

                    // Add loading state to button
                    const $btn = $(this);
                    const originalText = $btn.text();
                    $btn.prop('disabled', true)
                        .html('<i class="fa fa-spinner fa-spin"></i> ' + originalText);

                    // Hide modal and wait for it to fully close before continuing
                    $modal.modal('hide');
                    $modal.one('hidden.bs.modal', function() {
                        tradeloop?.scrollUnlock(); // In case "overflow: hidden" was not removed from the html element
                        resolve(true); // User proceeded
                    });
                });

                // Handle cancel button
                $(CANCEL_BUTTON_SELECTOR).on('click', function() {
                    if (debugMode) {
                        console.log('LOWBALL OFFER CANCELLED');
                    }

                    // Modal is being removed from DOM by click handler in base/index.js
                    // User cancelled
                    resolve(false);
                });
            });
        } else {
            resolve(true); // Not a lowball, continue
        }
    });
}
